var render = function render(){var _vm=this,_c=_vm._self._c;return _c('collect-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"collect-data":_vm.collectData,"launchUrl":_vm.launchUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }